import * as React from 'react';
import { observer } from 'mobx-react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';
import { currency } from 'src/util/formatters';
import moment from 'moment';
import styles from './confirmation-modal.less';

interface Props {
    companyName: string;
    companyPhoneNumber: string;
    amount: number;
    accountNumber: string;
    onClose: () => void;
    onSubmit: () => void;
}

export const ConfirmationModal = observer<React.SFC<Props>>(
    ({ amount, accountNumber, companyName, companyPhoneNumber, onClose, onSubmit }) => {
        const prettyAmount = currency(amount);
        const prettyDate = moment().format('L');
        return (
            <Dialog
                open
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">ACH Payment Authorization</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        I authorize {companyName}, herein called COMPANY, to debit my bank account
                        for {prettyAmount} according to the following details:
                    </DialogContentText>
                    <table className={styles.achTable}>
                        <tbody>
                            <tr>
                                <td>Amount Authorized</td>
                                <td>{prettyAmount}</td>
                            </tr>
                            <tr>
                                <td>Date of Authorization</td>
                                <td>{prettyDate}</td>
                            </tr>
                            <tr>
                                <td>Date of Debit</td>
                                <td>{prettyDate}</td>
                            </tr>
                            <tr>
                                <td>Bank Account Number</td>
                                <td>
                                    Ending in{' '}
                                    {accountNumber.length > 0
                                        ? accountNumber.substr(accountNumber.length - 4)
                                        : ''}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <DialogContentText id="alert-dialog-description">
                        I understand that this authorization will remain in full force and effect
                        until I cancel this transaction by contacting COMPANY at{' '}
                        {companyPhoneNumber}. To complete this transaction, click the "Authorize"
                        button.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={styles.declineButton} onClick={onClose}>
                        Decline
                    </Button>
                    <Button onClick={onSubmit} color="primary">
                        Authorize
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
);
